import React from 'react';
import { animated } from 'react-spring';
import styles from './gradients.module.css';

const Gradients = [
  style => (
    <animated.div
      className={styles.gradientBlock}
      style={{
        ...style,
        background: 'radial-gradient(at bottom left, #1805C1, #2AD9C7)',
      }}
    />
  ),
  style => (
    <animated.div
      className={styles.gradientBlock}
      style={{
        ...style,
        background: 'radial-gradient(at bottom left, #8837B6, #1805C1)',
      }}
    />
  ),
  style => (
    <animated.div
      className={styles.gradientBlock}
      style={{
        ...style,
        background: 'radial-gradient(at bottom left, #8237B7, #F1319E)',
      }}
    />
  ),
  style => (
    <animated.div
      className={styles.gradientBlock}
      style={{
        ...style,
        background: 'radial-gradient(at bottom left, #2AD9C7, #1805C1)',
      }}
    />
  ),
];

export default Gradients;



// WEBPACK FOOTER //
// ./src/components/gradient-bg-transition/gradients/index.js